import "../assets/index-8aa4712e.css";
import { n } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
const s = {
  name: "NcGuestContent",
  mounted() {
    document.getElementById("content").classList.add("nc-guest-content");
  },
  destroyed() {
    document.getElementById("content").classList.remove("nc-guest-content");
  }
};
var _ = function() {
  var t = this, e = t._self._c;
  return e("div", { attrs: { id: "guest-content-vue" } }, [t._t("default")], 2);
}, c = [], o = /* @__PURE__ */ n(
  s,
  _,
  c,
  !1,
  null,
  "36ad47ca",
  null,
  null
);
const r = o.exports;
export {
  r as default
};
